export const getUserData = (is_user) => {
  if (!is_user?.id) {
    return null;
  }
  const { id, name, email } = is_user;
  return { id, name, email };
};
